"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Layouts = require("layouts");
var Snippets = require("snippets");
var flexible_1 = require("./flexible");
var DefaultPageTemplate = /** @class */ (function (_super) {
    __extends(DefaultPageTemplate, _super);
    function DefaultPageTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultPageTemplate.prototype.render = function () {
        var page = this.props.data.page;
        if (this.props.sections.length > 0) {
            return React.createElement(flexible_1.FlexiblePageTemplate, __assign({}, this.props));
        }
        else {
            return (React.createElement(Layouts.Theme, __assign({}, this.props),
                React.createElement(Snippets.Container, { tag: "section", className: "flex flex-col md:flex-row items-center py-2-4" },
                    React.createElement("div", { className: "hidden lg:block w-1/4" },
                        React.createElement(Snippets.Breadcrumbs, __assign({}, this.props))),
                    React.createElement("div", { className: "w-full lg:w-1/2 text-center" }, page.title ? (React.createElement(Snippets.Heading, { size: "h4", tag: "h1", className: "font-bold leading-normal" }, page.title)) : null),
                    React.createElement("div", { className: "hidden lg:block w-1/4" })),
                React.createElement(Snippets.Container, { tag: "section", width: "sm", className: "md:pb-2-4" }, page.content ? React.createElement(Snippets.RichText, { size: "small" }, page.content) : null)));
        }
    };
    return DefaultPageTemplate;
}(React.Component));
exports.DefaultPageTemplate = DefaultPageTemplate;
